export default {
  nextAction: 'Prochaine action',
  CANDIDATE_ACCEPT_CONTACT_REQUEST: "En attente de l'acceptation de la demande de contact",
  CANDIDATE_ANSWER_PENDING_QUESTION: 'En attente des réponses aux questions',
  RECRUITER_BOOKMARK_CANDIDATE: 'Engager le candidat',
  RECRUITER_MONETIZE_CANDIDATE: 'Engager le candidat',
  CANDIDATE_ADD_JOB_INTEREST: "Aucun intérêt d'emploi correspondant",
  CANDIDATE_UPDATE_EXPERIENCE: 'Expérience insuffisante',
  CANDIDATE_UPDATE_WHERE_TO_WORK: 'Aucun lieu de travail défini',
  CANDIDATE_WAIT_FOR_OPEN_REQUISITION: "Aucune offre d'emploi ouverte",
  CANDIDATE_UPDATE_AVAILABILITY: 'En attente de la mise à jour des disponibilités',
  CANDIDATE_REVIEW_ANSWER: 'En attente de la révision des réponses',
  CANDIDATE_UPDATE_SURPLUS_EXPERIENCE: 'Surqualifié',
  RECRUITER_REVIEW_FOR_PAUSED: 'Réviser les réponses incorrectes aux questions',
  RECRUITER_REVIEW_FOR_KNOCKOUT_FROM_QA: 'A répondu incorrectement à une question éliminatoire',
  RECRUITER_SEND_MODERN_HIRE_REQUEST: "En attente de la demande d'évaluation des compétences",
  RECRUITER_SEND_LE_REQUEST: "Envoyer le test d'évaluation linguistique",
  RECRUITER_SEND_APPOINTMENT_REQUEST: "Admissible à la demande d'entrevue",
  RECRUITER_SEND_OFFER: "Admissible à l'envoi d'une offre",
  RECRUITER_ADD_TOKENS: 'Ajouter un jeton de monétisation',
  CANDIDATE_COMPLETE_MODERN_HIRE: 'En attente de la fin du processus Modern Hire',
  TO_BE_DISMISSED_MH: 'En attente du rejet - Échec du test de compétences',
  CANDIDATE_COMPLETE_LE: "En attente de la fin de l'évaluation linguistique",
  RECRUITER_EVALUATE_LE: "Réviser les résultats de l'évaluation linguistique",
  TO_BE_DISMISSED_LE: "En attente du rejet - Échec de l'évaluation linguistique",
  CANDIDATE_UPDATE_MAX_WORKING_HOURS: "Moins d'heures de travail par semaine",
  CANDIDATE_ACCEPT_APPOINTMENT_REQUEST: "En attente de l'acceptation de l'entrevue",
  RECRUITER_UPDATE_AVAILABILITY: "Disponibilité insuffisante pour l'entrevue",
  ATTEND_INTERVIEW: 'Entrevue planifiée',
  RECRUITER_RESCHEDULE_INTERVIEW: "Reporter l'entrevue",
  RECRUITER_RESCHEDULE_INTERVIEW_CANDIDATE_NO_SHOW: 'Entrevue incomplète - Absence du candidat',
  RECRUITER_RESCHEDULE_INTERVIEW_RECRUITER_NO_SHOW: 'Entrevue incomplète - Absence du recruteur',
  RECRUITER_INCOMPLETE_INTERVIEW_CANDIDATE_NO_SHOW: 'Entrevue incomplète - Absence du candidat',
  RECRUITER_INCOMPLETE_INTERVIEW_OR_RECRUITER_NO_SHOW: 'Entrevue incomplète - Absence du recruteur',
  RECRUITER_NEED_TO_RATE: "Doit évaluer l'entrevue",
  RECRUITER_DISMISS_CANDIDATE_FOR_LOW_RATING: 'Entrevue terminée - Faible évaluation',
  CANDIDATE_WAIT_FOR_INTERVIEW_SLOT: "Nombre maximal d'entrevues simultanées atteint",
  CANDIDATE_WAIT_FOR_AVAILABILITY_SLOT: 'Ajouter des disponibilités',
  CANDIDATE_WAIT_FOR_INTERVIEW_THRESHOLD: 'Entrevue passée récemment',
  CANDIDATE_ACCEPT_OFFER: "En attente de l'acceptation de l'offre",
  RECRUITER_SEND_SCREENING: 'Envoyer la vérification des antécédents',
  RECRUITER_SEND_HIRE_FORM: "Envoyer le formulaire d'embauche",
  RECRUITER_SEND_I9_REQUEST: 'Envoyer la vérification I-9',
  RECRUITER_HIRE_CANDIDATE: "Finaliser l'embauche",
  OFFER_REJECTED_BY_RECRUITER_REVIEW_CANDIDATE: 'Réviser le candidat - Offre refusée',
  TO_BE_DISMISSED_OFFER_REJECTED: 'En attente du rejet - Offre refusée',
  REVIEW_CANDIATE_OFFER_REJECTED_SEEKER: 'Réviser le candidat - Offre refusée',
  RECRUITER_SEND_NEW_OFFER: "Admissible à l'envoi d'une offre",
  TO_BE_DISMISSED_OFFER_REVOKED: 'En attente du rejet - Offre révoquée',
  REVIEW_CANDIDATE_OFFER_REVOKED: 'Réviser le candidat - Offre révoquée',
  CANDIDATE_COMPLETE_SCREENING: 'En attente de la fin de la vérification des antécédents',
  RECRUITER_REVIEW_SCREENING_REPORT: 'Réviser les résultats de la vérification des antécédents',
  CANDIDATE_FILL_HIRE_FORM: "En attente de la fin du formulaire d'embauche",
  RECRUITER_RESPOND_HELP_REQUEST: "Répondre à la demande d'aide pour le formulaire d'embauche",
  RECRUITER_EVALUATE_HIRE_FORM: "Réviser le formulaire d'embauche complété",
  TO_BE_DISMISSED_HIRE_FORM_REJECTED: "En attente du rejet - Formulaire d'embauche refusé",
  CANDIDATE_FILL_I9: 'En attente de la fin du formulaire I-9',
  CANDIDATE_RESUBMIT_I9: 'En attente de la nouvelle soumission du formulaire I-9',
  RECRUITER_EVALUATE_I9: 'Réviser la soumission du formulaire I-9',
  END_OF_WORKFLOW: '',
};
